export default {
  opportunities: {
    id: 'bo_seller-homepage-opportunities',
    defaultMessage: 'Opportunities',
  },
}
